import { gql } from "@apollo/client"

export const PRODUCTIONS = gql`
  query Productions(
    $search: String
    $exportCustomerId: ID
    $sendForApproval: Boolean
    $limit: Int
    $offset: Int
    $varietyId: ID
    $fromDate: Date
    $toDate: Date
    $productionStatus: String
  ) {
    productions(
      search: $search
      exportCustomerId: $exportCustomerId
      sendForApproval: $sendForApproval
      limit: $limit
      offset: $offset
      varietyId: $varietyId
      fromDate: $fromDate
      toDate: $toDate
      productionStatus: $productionStatus
    ) {
      id
      createdAt
      weeklySrNo
      supervisorNames
      certificateNumbers
      farmerNames
      gatePasses
      shipmentPlan {
        id
        soNo
        skuFilled
        exportCustomer {
          id
          name
        }
        varieties {
          id
          name
        }
        varietyType
        skuType {
          id
          name
        }
      }
      productionLine {
        id
        name
      }
      sendForApproval
      metadata
    }
  }
`

export const PRODUCTION_BY_ID = gql`
  query Production($id: ID!) {
    production(id: $id) {
      id
      sendForApproval
      metadata
      productionLine {
        id
        name
      }
      weeklySrNo
      shipmentPlan {
        id
        soNo
        skuFilled
        metadata
        exportCustomer {
          id
          name
        }
        colourGroup {
          id
          name
        }
        skuType {
          id
          name
          capacity
          capacityUnit {
            id
            name
            codename
          }
        }
        varietyType
        varieties {
          id
          name
        }
        primaryPackMaterial {
          id
          name
        }
        secondaryPackMaterial {
          id
          name
        }
        labels
        approvedtradeprofileSet {
          id
          tradeProfile {
            id
            certificateNumber
            availableYield
            plotYeild
          }
          boxCount
        }
      }
      productionitemSet {
        id
        createdAt
        sequenceNumber
        palletNo
        boxCount
        remark
        palletType
        metadata
        linetradeprofileSet {
          id
          assignedWt
          availableWt
          approvedTradeProfile {
            id
            tradeProfile {
              id
              certificateNumber
              plotCommodity {
                id
                name
                variety {
                  id
                  name
                  commodity {
                    id
                    name
                  }
                }
                plot {
                  id
                  name
                  farmer {
                    id
                    fullName
                    documents {
                      id
                      certificationType {
                        id
                        name
                        codename
                      }
                      idNumber
                    }
                  }
                }
              }
            }
          }
        }
        linepackingallotmentSet {
          id
          lotCode
          createdAt
          productionCreatedDate
          assignedWt
          availableWt
          rejectionWt
          rejectionBoxCount
          packingAllotment {
            id
            inwardAllocation {
              id
              inward {
                id
                booking {
                  id
                  schedule {
                    id
                    gatePass
                    variety {
                      id
                      name
                    }
                    plotCommodity {
                      id
                      registrationCode
                    }
                    plot {
                      farmer {
                        id
                        fullName
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const MH_CODE_SELECTOR = gql`
  query MhCodeSelector($id: ID!) {
    production(id: $id) {
      id
      weeklySrNo
      shipmentPlan {
        id
        metadata
        skuType {
          id
          name
          capacity
        }
        varieties {
          id
          name
        }
        approvedtradeprofileSet {
          id
          tradeProfile {
            id
            certificateNumber
            availableYield
            plotYeild
            extraPlotYeild
            extraAvailableYield
            plotCommodity {
              variety {
                id
                name
              }
              plot {
                id
                farmer {
                  id
                  fullName
                  address {
                    id
                    address
                  }
                }
              }
            }
          }
          boxCount
          availableYield
        }
      }
    }
  }
`

export const GATE_PASS_SELECTOR = gql`
  query GatepassSelector(
    $productionItemId: ID
    $search: String
    $limit: Int
    $offset: Int
    $productionLineId: ID
    $productionId: ID
  ) {
    gatepassSelector(
      productionId: $productionId
      productionItemId: $productionItemId
      search: $search
      limit: $limit
      offset: $offset
      productionLineId: $productionLineId
    ) {
      id
      createdAt
      id
      allotedQuantity
      allotedWeight
      consumedWeight
      rejectedWeight
      rejectedQuantity
      inwardAllocation {
        id
        inward {
          id
          booking {
            schedule {
              id
              gatePass
              variety {
                id
                name
                referenceId
                parentVariety {
                  id
                  name
                }
              }
              plotCommodity {
                id
                registrationCode
              }
              plot {
                id
                farmer {
                  id
                  fullName
                  address {
                    id
                    address
                  }
                }
              }
            }
          }
        }
      }
      selected
    }
  }
`

export const RESTOCK_PRODUCTION = gql`
  mutation RestockProduction($input: RestockProductionInput!) {
    restockProduction(input: $input) {
      ok
      message
    }
  }
`

export const ADD_REMARK_PRODUCTION_ITEM = gql`
  mutation AddRemarkProductionItem($input: AddRemarkProductionItemInput!) {
    addRemarkProductionItem(input: $input) {
      ok
      message
    }
  }
`
